import React, { useImperativeHandle } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
/* aca se cambia el estilo del contenido */
const useStyles = makeStyles(theme => ({
  appMainContent: {
    flex: 1,
    display: 'flex',
    overflowY: 'hidden',
    overflowX: 'hidden',
    flexDirection: 'column',
    boxSizing: 'border-box',
    padding: '0px 15px',
    [theme.breakpoints.up('md')]: {
      paddingLeft: 50,
      paddingRight: 50,
    },
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 2,
      paddingRight: 0,
    },
    [theme.breakpoints.up('xl')]: {
      paddingLeft: 2,
      paddingRight: 0,
    },
    [theme.breakpoints.down('sm')]: {
      paddingTop: 2,
      paddingBottom: 0,
    },
  },
}));

const CmtContent = React.forwardRef(function LayoutContent(props, ref) {
  const { children } = props;

  useImperativeHandle(ref, () => ({}));

  const contentRef = React.createRef();
  const classes = useStyles();

  return (
    <Box ref={contentRef} className={clsx(classes.appMainContent, 'Cmt-appMainContent')} bgcolor="background.main">
      {children}
    </Box>
  );
});

export default CmtContent;
CmtContent.defaultProps = {
  name: 'LayoutContent',
};
